__webpack_require__.p = "/de/knx-configurator/";